// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"style_mainCont__28R5b"};